import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import SystemComponentsViewModel from "viewModels/administration/systemComponents/systemComponentsViewModel";
import type SystemComponent from "entities/systemComponent";
import ListView from "../../common/list";

const SystemComponentsView: ViewComponent<SystemComponentsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<SystemComponent>[] = [
    {
      title: vm.translateAttribute("name"),
      property: "name",
    },
    {
      title: vm.translateAttribute("code"),
      property: "code",
    },
    {
      title: vm.translateAttribute("state"),
      property: "state",
      valueFormatter: props => vm.translateState(props.value),
    },
  ];

  return <ListView columns={columns} vm={vm} />;
});

registerView(SystemComponentsView, SystemComponentsViewModel);
